import React, { Component } from 'react';
import { observer } from 'mobx-react';
import LeftPanelItem from "Components/LeftPanel/leftPanelItem";

class LeftPanelItemsStats extends Component {

    constructor() {
        super();
    }

    render() {
        return (
            <div>
                <LeftPanelItem
                    title='Назад'
                    linkTo={`${window.SmrLocation}/`}
                    icon="us-back-menu"
                    isSelected={true}
                />
                <LeftPanelItem
                    title='Пользователи'
                    linkTo="#sectionUsersCount"
                    icon="users-menu"
                />
                <LeftPanelItem
                    title='Документы'
                    linkTo="#sectionDocumentsMaxCountLinkedDocuments"
                    icon="documents-in-folder-menu"
                />
                <LeftPanelItem
                    title='Файлы'
                    linkTo="#sectionDocumentsMaxSizeFiles"
                    icon="document-page-menu"
                />
                <LeftPanelItem
                    title='Поручения и отчеты'
                    linkTo="#sectionDocumentsMaxCountResolutions"
                    icon="us-resolutions-menu"
                />
                <LeftPanelItem
                    title='Подписи и визы'
                    linkTo="#sectionDocumentsMaxCountVisas"
                    icon="us-eds-menu"
                />
                <LeftPanelItem
                    title='Синх. с СЭД'
                    linkTo="#sectionUnprocessedEvents"
                    icon="us-sync-menu"
                />
            </div>
        );
    }
}

export default observer(LeftPanelItemsStats);